import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const MAX_HISTORY_LENGTH = 200;
const historyStack = [];

const normalizeEntry = (location) => {
  const path = location.pathname || '/';
  const search = location.search || '';
  const hash = location.hash || '';
  return `${path}${search}${hash}`;
};

export const useNavigationTracker = () => {
  const location = useLocation();

  useEffect(() => {
    const entry = normalizeEntry(location);
    const lastEntry = historyStack[historyStack.length - 1];

    if (lastEntry !== entry) {
      historyStack.push(entry);
      if (historyStack.length > MAX_HISTORY_LENGTH) {
        historyStack.shift();
      }
    }
  }, [location]);
};

export const popNavigationHistory = ({ skipAuthRoutes = false } = {}) => {
  if (historyStack.length <= 1) {
    return null;
  }

  // Drop the current view
  historyStack.pop();

  while (historyStack.length) {
    const candidate = historyStack.pop();
    if (!candidate) {
      continue;
    }

    const pathOnly = candidate.split('?')[0];
    const isAuthRoute = pathOnly === '/login' || pathOnly === '/signup';
    if (skipAuthRoutes && isAuthRoute) {
      continue;
    }

    return candidate;
  }

  return null;
};

export const getHistorySnapshot = () => historyStack.slice();
